<template>
  <div id="app" class="min-h-screen bg-surface">
    <div v-if="authLoading" class="min-h-screen flex items-center justify-center">
      <div class="flex flex-col items-center gap-4">
        <svg class="animate-spin h-12 w-12 text-navy dark:text-text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-text-secondary text-sm">Loading...</p>
      </div>
    </div>
    <RouterView v-else />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { useTheme } from '@/composables/useTheme'

useTheme()

const { isLoading: authLoading } = useAuth()
</script>
